/* eslint-disable */
export default {
  methods: {
    initOneSignal: function (selectedLocation) {
      // if cordova is present then the device being used should be a mobile
      if (window.cordova) {
        // NOTE: Update the setAppId value below with your OneSignal AppId.
        window.plugins.OneSignal.initialize(
          "7e991e3a-bb92-41f1-ae43-7862f1caca21"
        );

        // function to handle the opening of a notification
        window.plugins.OneSignal.Notifications.addEventListener(
          "click",
          (event) => {
            const redirectUrl = event.notification.additionalData.redirectURL;

            if (redirectUrl) {
              window.location.replace(redirectUrl);
            }
          }
        );

        // method to prompt the user for push notifications
        window.plugins.OneSignal.Notifications.requestPermission(false).then(
          (accepted) => {
            console.log("User accepted notifications: " + accepted);
          }
        );

        // method for sending a custom tag, uncomment to use
        if (selectedLocation && selectedLocation.length > 0) {
          window.plugins.OneSignal.User.addTag("location", selectedLocation);
        }
      }
    },
    setStatusBarStyles: function () {
      if (window.cordova) {
        // NOTE: Update the setAppId value below with your OneSignal AppId.
        window.plugins.OneSignal.initialize(
          "7e991e3a-bb92-41f1-ae43-7862f1caca21"
        );

        // Setting the status bar to appear above the app content and not overlay
        StatusBar.overlaysWebView(false);

        // Setting the status bar background color
        StatusBar.backgroundColorByHexString("#000000");

        // Sets the status bar text color to a default dark color, which is suitable for light-colored backgrounds
        // StatusBar.styleDefault();

        // Sets the status bar text color to light, which is suitable for dark-colored backgrounds
        StatusBar.styleLightContent();
      }
    },
    updateOneSignalLocation: function (selectedLocation) {
      if (window.cordova) {
        window.plugins.OneSignal.initialize(
          "7e991e3a-bb92-41f1-ae43-7862f1caca21"
        );

        if (selectedLocation && selectedLocation.length > 0) {
          window.plugins.OneSignal.User.addTag("location", selectedLocation);
        }
      }
    },
  },
};
/* eslint-enable */
